import script from './SdsInputSearch.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsBaseInput',{ref:"baseInputRef",staticClass:"sds-input-search",attrs:{"name":_vm.name,"value":_vm.value,"label":_vm.label,"autocomplete":_vm.autocomplete,"placeholder":_vm.placeholder,"dataTestId":_vm.dataTestId,"autofocus":_vm.autofocus,"type":"text","isClearable":true,"size":"sm"},on:{"update:value":function($event){return _vm.$emit('update:value', $event)},"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"click":function($event){return _vm.$emit('click', $event)},"keydown":function($event){return _vm.$emit('keydown', $event)},"keypress":function($event){return _vm.$emit('keypress', $event)},"keyup":function($event){return _vm.$emit('keyup', $event)},"cleared":function($event){return _vm.$emit('cleared')}},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('label',{staticClass:"sds-input-search__label",attrs:{"for":_vm.htmlInputIdRef}},[_c('SdsIcon',{staticClass:"sds-input-search__icon",attrs:{"iconName":"navigation-search","size":"sm"}})],1)]},proxy:true}])})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-93e3bba8_0", { source: ".sds-input-search__label[data-v-93e3bba8]{display:flex;align-items:center;cursor:pointer}.sds-input-search__icon[data-v-93e3bba8]{color:var(--system-graphics-on-elevation-tertiary-on-body)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-93e3bba8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
